<template>
  <div>
    <f7-popup
      class="content-scan-popup"
      :close-by-backdrop-click="true"
      :opened="popupOpened"
      @popup:closed="popupOpened = false"
    >
      <f7-page>
        <f7-navbar>
          <f7-nav-left>
            {{ $t('commercialization.picking.palletizing.scanData.title') }}
          </f7-nav-left>
          <f7-nav-right>
            <f7-link
              popup-close
              class="panel-close"
            >
              <img
                alt="iconClose"
                :src="icClose"
              >
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-toolbar position="bottom">
          <f7-link
            class="ligh"
            @click="Cancel"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </f7-link>
          <f7-link
            class="strong"
            @click="Confirm"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </f7-link>
        </f7-toolbar>

        <div
          v-if="dataPale != null"
          class="content-scan-popup-list padding"
        >
          <div class="content-scan-popup-list__item padding-horizontal padding-top">
            <span class="content-scan-popup-list__item--ligh">
              {{ $t('common.pallet').toUpperCase() }}
            </span>
            <span class="content-scan-popup-list__item--strong">{{ dataPale.NumeroSerie }}</span>
          </div>
          <div class="content-scan-popup-list__item padding-horizontal padding-top">
            <span class="content-scan-popup-list__item--ligh">
              {{ $t('common.article').toUpperCase() }}
            </span>
            <span
              v-if="dataPale.InfoProducto != null"
              class="content-scan-popup-list__item--strong"
            >{{ dataPale.InfoProducto.Descripcion }}</span>
            <span
              v-else
              class="content-scan-popup-list__item--strong"
            > {{ GetProductFromPale(dataPale) }} </span>
          </div>
          <div class="content-scan-popup-list__item padding-horizontal padding-top">
            <span class="content-scan-popup-list__item--ligh">
              {{ $t('commercialization.picking.palletizing.scanData.labels.availablePackages').toUpperCase() }}
            </span>
            <span class="content-scan-popup-list__item--strong">{{ GetNumberContainersFromPale(dataPale) }}</span>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </div>
</template>

<script>
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import icClose from '@/static/icons/ic_close_blue.svg';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCPopupScanData',

  emits: ['confirm'],

  data() {
    return {
      popupOpened: false,
      dataPale: null,
      icClose,
    };
  },
  methods: {
    /**
     * @public
     * @returns {void}
     */
    Show(pale) {
      Log(this, this.Show.name);
      this.dataPale = pale;
      this.popupOpened = true;
    },
    Confirm() {
      Log(this, this.Confirm.name);
      f7.popup.close('.content-scan-popup');
      this.$emit('confirm', this.dataPale);
    },
    Cancel() {
      Log(this, this.Cancel.name);
      f7.popup.close('.content-scan-popup');
    },
    GetProductFromPale(objPale) {
      Log(this, this.GetProductFromPale.name);
      const tempProducto = objPale.Existencias.find((e) => e.Articulo.TipoArticulo === 'Producto');
      return tempProducto.Articulo.Descripcion;
    },
    GetNumberContainersFromPale(objPale) {
      Log(this, this.GetNumberContainersFromPale.name);
      const tempAcumExitenciasEnvases = objPale.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase');
      return tempAcumExitenciasEnvases.reduce((accumulator, object) => accumulator + object.Cantidad, 0); // Suma de todos los acumulados de tipo envase
    },
  },
};
</script>

<style lang="scss">
.content-scan-popup {
  --f7-popup-tablet-width: 385px;
  --f7-popup-tablet-height: 420px;

  .navbar {
    --f7-navbar-text-color: var(--his-steel-blue);

    background-color: #dfe1e5;
    --f7-bars-translucent-opacity: 0;

    font-size: 18px !important;
    font-weight: 400;

    .navbar-bg {
      background-color: transparent;
    }

    .navbar-inner {
      padding-left: var(--f7-typography-padding) !important;
      padding-right: var(--f7-typography-padding) !important;
    }
  }

  .content-scan-popup-list {
    &__item {
      display: flex;
      flex-direction: column;

      &--strong {
        color: var(--his-steel-blue);
        font-size: 18px;
        font-weight: 500;
      }

      &--ligh {
        color: var(--his-oliva);
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .toolbar {
    --f7-toolbar-height: 60px;
    --f7-toolbar-bg-color: #fff;

    .toolbar-inner {
      padding: var(--f7-typography-padding) !important;
    }

    .link {
      padding-left: var(--f7-typography-padding) !important;
      padding-right: var(--f7-typography-padding) !important;

      &.strong {
        color: var(--his-steel-blue);
        font-size: 18px;
        font-weight: 500;
      }

      &.ligh {
        color: #c1c1c1;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}

.searchPale {
  height: 75px;
}

.btn-popup-cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #c1c1c1;
  width: 150px;
}

.popup-info {
  padding: 20px;

  &_fila {
    font-family: "Roboto Medium";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--his-oliva);
    margin-bottom: 20px;
    margin-top: 20px;
  }

  &_valor {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: var(--his-steel-blue);
    mix-blend-mode: normal;
    margin-top: 10px;
  }
}
</style>
